import { Controller } from 'stimulus';
import MediaMatcher from 'lib/media-matcher';

const mediaMatcher = new MediaMatcher();

export default class VideoPreviewController extends Controller {
  static targets = [
    'preview',
  ];

  videoSelector = '[data-target*="video-preview.preview"]';

  // eslint-disable-next-line consistent-return
  connect() {
    if (!this.hasPreviewTarget) return false;

    this.setupPreviewMediaQueries();

    document.addEventListener('play', this.pauseHiddenVideos, true);

    mediaMatcher.evaluateAll();
    mediaMatcher.addListeners();
  }

  disconnect() {
    this.removeListeners();

    mediaMatcher.removeListeners();
    mediaMatcher.clearQueries();
  }

  removeListeners() {
    document.removeEventListener('play', this.pauseHiddenVideos);

    this.removePreviewEvents();
  }

  addPreviewEvents = () => {
    this.previewTargets.forEach((preview) => {
      preview.addEventListener('mouseenter', this.playVideo, false);
      preview.addEventListener('mouseleave', this.maybePauseVideo, false);
    });
  }

  removePreviewEvents = () => {
    this.previewTargets.forEach((preview) => {
      preview.removeEventListener('mouseenter', this.playVideo);
      preview.removeEventListener('mouseleave', this.maybePauseVideo);
    });
  }

  pauseHiddenVideos = (event) => {
    const videos = this.element.querySelectorAll('video');

    videos.forEach((video) => {
      if (video !== event.target) {
        this.pauseVideo(video, true);
      }
    });
  }

  addVideoToDOM(gridItem) {
    const { videoUrl } = gridItem.dataset;
    const videoHTML = `<div class="video-wrapper">
                        <video autoplay="true" preload="none" muted playsinline>
                          <source src="${videoUrl}" type="video/mp4">
                        </video>
                      </div>`;

    const videoWrap = gridItem.querySelector('[data-target*="video-preview.videoWrap"]');

    videoWrap.insertAdjacentHTML('beforeend', videoHTML);
  }

  playVideo = (event) => {
    event.stopPropagation();

    const gridItem = event.currentTarget;

    if (!gridItem.querySelector('video')) {
      this.addVideoToDOM(gridItem);
    }

    this.videoPlayIntent = setTimeout(() => {
      const video = gridItem.querySelector('video');

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.then(() => {
          video.loop = true;

          if (video.readyState >= 3) {
            gridItem.classList.add('is-playing');
          }
        });
      }
    }, 150);
  }

  isPlaying(video) {
    const isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;

    return isPlaying;
  }

  pauseVideo(video, reset = false) {
    if (this.isPlaying(video)) {
      video.closest(this.videoSelector).classList.remove('is-playing');
      video.pause();

      if (reset) video.currentTime = 0;
    }
  }

  maybePauseVideo = (event) => {
    clearTimeout(this.videoPlayIntent);

    const video = event.currentTarget.querySelector('video');

    if (!video.closest(this.videoSelector).classList.contains('is-active')) {
      this.pauseVideo(video, true);
    }
  }

  setupPreviewMediaQueries() {
    mediaMatcher.addMediaQuery('(min-width: 1024px)',
      () => { this.addPreviewEvents(); },
      () => { this.removePreviewEvents(); });
  }
}
